import * as marietta from '../..';
import { WebcadJsonData } from '../util/WebcadJSONExporter';
import { TempLidarPinControlDialog } from '../view/dialog';
import { WebcadJSONParser } from '../util';
import Main from '../../../main';
import { Mode3DTool } from '../../view3d/webcad/util/Mode3DTool';
import { optAutoIntersectMode, optRecognizeMode } from '../../view3d/webcad/util/Option3DInterface';
import { ITEM_MODE_NAME_ENG } from '../Constants';

export interface AdditionalPinData{
  planData:WebcadJsonData;
  imgBinary:{name:string, src:string}[];
}
export default class AddLidarPinManager {
  public _importObject: marietta.webcad.item.TemporaryGroupItemForLidarAddPin;

  public controllerDialog:TempLidarPinControlDialog;

  startImportWizard(info:AdditionalPinData):void {
    // ピンデータがない場合
    const pinList = WebcadJSONParser.extractFreeTextItem(info.planData.plan.text).filter((item) => item.floor === 1);
    if (pinList.length < 1) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JSON_IMPORT_LIDAR_ADDITIONAL_PIN_FAIL'));
      marietta.webcad.WebCADGlobal.hideBusy();
      return;
    }

    this._importObject = new marietta.webcad.item.TemporaryGroupItemForLidarAddPin(info);
    this._importObject.cancelCallBack = this.cancelImport;

    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
    Main.btnHeaderSelectModeClickEventHandler();

    // 画面切り替え
    this.modeDisplayForAddPin(true);
    this.modeLimitEventForAddPin(true);
    // アイテムレイヤー透過切り替え
    this.opacityItemLayer(true);

    const tarLayer: marietta.webcad.layer.LidarImportLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer('ldr', marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.LidarImportLayer;
    (tarLayer as marietta.webcad.layer.LidarImportLayer).addParts(this._importObject);
    // 取り込みデータの絶対座標のままだと画面外に配置され、ピン・コントローラーが見えず
    // 操作できない（半透明のまま固まる）。表示中心へ寄せてから操作コントローラーを生成する。
    this._importObject.centerInView();
    marietta.webcad.WebCADGlobal.itemManager.itemController = new marietta.webcad.control.ItemControllerLidarAddPin(this._importObject);

    // this.controllerDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.TempLidarPinControlDialog, true, false) as TempLidarPinControlDialog;
    // this.controllerDialog.cancelCallBack = this.cancelImport;

    // ピンを追加取り込み
    this.applyAddPin();
  }

  /**
   * 画面切り替え
   */
  private modeDisplayForAddPin(bool: boolean) {
    // メニュー表示切り替え
    document.getElementById('headerMenu2D').style.display = bool ? 'none' : 'block';
    document.getElementById('changeDimensionBtns').style.display = bool ? 'none' : 'block';
    document.getElementById('headerMenuRight').style.display = bool ? 'none' : 'block';
    // ピン登録完了ボタン
    document.getElementById('btnAddLidarPin').style.display = bool ? 'block' : 'none';
  }

  /**
   * イベント伝搬可否制御
   */
  private modeLimitEventForAddPin(bool: boolean): void {
    document.getElementById("itemMenuWrap").style.pointerEvents = bool ? 'none' : 'auto';
  }

  /**
   * アイテムレイヤー透過切り替え
   * @param bool
   */
  private opacityItemLayer(bool: boolean): void {
    [...document.getElementById(`floor${marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor}`).children].forEach((child) => {
      if ([ITEM_MODE_NAME_ENG.MODE_LIDAR_NAME_ENG].some(id => id === (child as SVGGElement).id)) return;

      // STARTS様より: ピン登録時は元図面に透過をかけたい
      (child as SVGGElement).style.opacity = bool ? '0.6' : '1';
    });
  }

  /**
   * ピンを追加で取り込み
   */
  private applyAddPin(): void {
    const apply = () => {
      const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
      const targetLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor).layer_lidar_import;
      const targetItem = targetLayer.getchildList()[0];
      const pinList = targetItem.insertPinsToPlan();
      const markList = targetItem.insertMarksToPlan();
      targetItem.deleteMe();

      // ピン登録モードOFF 画面切り替え
      this.modeDisplayForAddPin(false);
      this.modeLimitEventForAddPin(false);
      // 透過切り替え
      this.opacityItemLayer(false);

      // itemcontroller未適用
      marietta.webcad.WebCADGlobal.itemManager.itemController = null;
      document.getElementById('controller')?.remove();

      // 画像検知マーク適用(recognize)とピン自動紐付け(auto-intersect)は同一の3Dロードで
      // 両方走らせられない。auto-intersect は末尾で changeMode2D()→finished3d()→resetData() を
      // 呼び GltfExtras を破棄するため、後続の recognize が GltfExtras.model_center 参照で落ちる。
      // （加えて Mode3DTool.option は static なので start() を2回呼ぶのも不可。）
      // よって start() は1回だけにし、マークがある場合は画像検知を優先する。
      // ピンの自動紐付けはスキップし、後からヘッダーの手動紐付けで対応する。
      const hasPins: boolean = pinList.length > 0;
      const hasMarks: boolean = markList.length > 0;
      if (hasMarks) {
        // 画像検知マークの適用
        const mode3d = new Mode3DTool();
        const option: optRecognizeMode = { isRecogninzeMode: true, showWizardDialog: false, markList: markList };
        mode3d.setOption(option);
        mode3d.start();
      } else if (hasPins) {
        // ピンの自動紐付け
        const mode3d = new Mode3DTool();
        mode3d.setOption(<optAutoIntersectMode>{ isAutoIntersectMode: true });
        mode3d.start();
      }
    }

    document.getElementById('btnAddLidarPin').addEventListener('click', apply, {once: true});
  }

  /**
   * 取り込みキャンセル
   */
  public cancelImport = () => {
    const self:AddLidarPinManager = this;

    // ダイアログを閉じる
    if (self.controllerDialog) self.controllerDialog.closeEvent();

    // 削除
    self._importObject.deleteMe();
  }
}
